import { useContext, useState, useEffect, useMemo } from 'react';
import { CARLINE_QUERY } from '../queries/carlineQuery';
import { Context } from '../Context';
import type { CarlinePricesForStageFaQuery } from '../../generated/onegraph';

export const useDataFromOneGraph = (
  id: string | undefined,
): CarlinePricesForStageFaQuery | undefined => {
  const { localeService, oneGraphService, loggerService } = useContext(Context);
  const oneGraphClient = oneGraphService?.getApolloClient();

  const [oneGraphData, setOneGraphData] = useState<CarlinePricesForStageFaQuery>();

  const consumerId = `${__FEATURE_APP_NAME__}@${__FEATURE_APP_VERSION__}`;
  const context = { consumerId };

  // Memoize CarlineIdentifierInput to prevent infinite loop
  const CarlineIdentifierInput = useMemo(() => {
    return {
      idType: 'carline',
      query: CARLINE_QUERY,
      variables: {
        identifier: {
          brand: localeService?.brand ?? 'A',
          language: localeService?.language ?? '',
          country: localeService?.countryCode ?? '',
          id: id ?? '',
        },
      },
    };
  }, [localeService?.countryCode, id]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!CarlineIdentifierInput) return;

        const response = await oneGraphClient?.query<CarlinePricesForStageFaQuery>({
          context,
          variables: { ...CarlineIdentifierInput.variables },
          query: CarlineIdentifierInput.query,
        });

        if (response !== undefined) {
          setOneGraphData(response.data);
        }
      } catch (error) {
        loggerService?.error('Error! carlines fetching data for fa-stage', error);
      }
    };

    if (oneGraphClient) {
      fetchData().catch((err) => {
        loggerService?.error('[fa-stage] Server Error fetching from GraphQL:', err);
      });
    }
  }, [oneGraphClient, CarlineIdentifierInput]);

  return oneGraphData;
};
